import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { ModalButtonSave, ModalButtonUpdate, } from '../../constant';
import { DeleteMicUnits } from './DeleteMicUnits';
import { FormMicUnits } from './FormMicUnits';
import { Dialog } from 'primereact/dialog';

export const ModalMicUnits = (props) => {

    const {
        modal, modalTitle, toggle, method, loading,
        unit, abbreviation, handleInputChange,
        validaciones, saveCreate, saveUpdate, saveDelete,
        closeDialog
    } = props;

    return (
        <Dialog header={modalTitle} visible={modal} onHide={closeDialog} closable={true} modal blockScroll className='medium-dialog'>

            {
                method === "create"
                    ?
                    < FormMicUnits
                        button={ModalButtonSave}
                        {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveCreate }}
                    />
                    :
                    (method === "update")
                        ?
                        < FormMicUnits
                            button={ModalButtonUpdate}
                            {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveUpdate, unit, abbreviation, }}
                        />
                        : null
            }
        </Dialog>
    )
}
